import axios from 'axios';
import { default as envConfig } from '@/config/runtimeConfig';

export type ScannedDevice = {
  serialNumber: string;
  manufacturer: string | null;
  rssi: number | null;
  lqi: number | null;
};

export type DeviceScanResponse = {
  startedAt: string | null;
  endedAt: string | null;
  state: 'NO_SCAN' | 'PENDING' | 'RUNNING' | 'CANCELLED' | 'FINISHED' | null;
  devices: ScannedDevice[];
};

export async function getDmgw6DeviceScan(
  gatewaySerialNumber: string
): Promise<DeviceScanResponse> {
  const { data } = await axios.get<DeviceScanResponse>(
    `${envConfig.backendBaseUrl}/gateways/${gatewaySerialNumber}/deviceScan`
  );
  return data;
}
